"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const selectors = __importStar(require("data/app/selectors"));
const selectors_2 = require("data/accountNodes/selectors");
const actions_1 = require("data/app/actions");
const paths_1 = require("containers/App/paths");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const actions_2 = require("components/Dialogs/WhatsNew/actions");
const actions_3 = require("components/Dialogs/ReleaseNotes/actions");
const actions_4 = require("components/Dialogs/HelpSupportDialog/actions");
const constants_1 = require("utils/constants");
const more_svg_1 = __importDefault(require("assets/more.svg"));
const utils_1 = require("../utils");
const currentVersion = process.env.APP_VERSION;
let whatsNewData;
try {
    // eslint-disable-next-line
    whatsNewData = require(`/static/whats-new${currentVersion}/WhatsNew.json`);
    if ((whatsNewData === null || whatsNewData === void 0 ? void 0 : whatsNewData.version) === currentVersion) {
        whatsNewData = {
            count: whatsNewData.pages,
            pages: whatsNewData.order.split(','),
        };
    }
}
catch (_a) {
    whatsNewData = {};
}
const MoreButton = ({ classes, hide, showRefreshIcon, featureFlags }) => {
    var _a;
    const [showMenuItems, setShowMenuItems] = React.useState(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { userPreferences, setUserPreference } = (0, useQPreferences_1.default)();
    const moreButtonRef = React.useRef(null);
    const timer = React.useRef(undefined);
    const isUserPrefLoading = (0, react_redux_1.useSelector)(selectors_1.getLoadPendingState).shared.user;
    const disableRefreshButton = (0, react_redux_1.useSelector)((state) => selectors.disableRefreshButton(state));
    const isRefreshing = (0, react_redux_1.useSelector)((state) => selectors.isRefreshing(state));
    const showReleaseNotes = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'showReleaseNotes'));
    // TODO: type assigning wont be needed once new app-component is installed
    const accountNodesTree = (0, react_redux_1.useSelector)(selectors_2.getAccountNodesTree);
    const hasWhatsNewJSON = ((_a = whatsNewData === null || whatsNewData === void 0 ? void 0 : whatsNewData.pages) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const dispatchShowWhatsNewDialog = () => dispatch((0, actions_2.showWhatsNewDialog)(whatsNewData, () => dispatch((0, actions_3.showReleaseNotesDialog)())));
    const dispatchShowReleaseNotesDialog = () => dispatch((0, actions_3.showReleaseNotesDialog)());
    const objMenuItemHandlers = {
        whatsNew: dispatchShowWhatsNewDialog,
        releaseNotes: dispatchShowReleaseNotesDialog,
        supportFAQ: () => dispatch((0, actions_4.doHelpSupportModal)()),
    };
    const moreOptions = React.useMemo(() => {
        const nav = paths_1.featurePages.find((x) => x.path === '/settings');
        const allOptions = constants_1.HELP_MENU_ITEMS.map(({ key, label }) => ({
            key,
            body: label,
            disabled: key === 'whatsNew' && !hasWhatsNewJSON,
            onClick: objMenuItemHandlers[key],
        }));
        if (!hide) {
            if (showRefreshIcon) {
                if (!disableRefreshButton && !isRefreshing) {
                    allOptions.push({
                        key: 'refresh',
                        body: 'Refresh',
                        disabled: false,
                        onClick: () => dispatch((0, actions_1.appRefreshAll)(undefined, { context: 'refreshAll' })),
                    });
                }
                else if (isRefreshing) {
                    allOptions.push({
                        key: 'refreshing',
                        body: <>
              <IconButton_1.default aria-label="Refresh All Busy" classes={{ root: classes.buttonRoot }} className={classes.spinnerButton}>
                <CircularProgress_1.default size={16}/>
              </IconButton_1.default>
              Refreshing 
              {/* eslint-disable-next-line react/jsx-closing-tag-location */}
            </>,
                        disabled: true,
                        onClick: undefined,
                    });
                }
            }
            if (nav && (!nav.featureFlag || featureFlags.get(nav.featureFlag))) {
                allOptions.push({
                    key: 'settings',
                    body: 'Settings',
                    disabled: false,
                    onClick: () => navigate('/settings'),
                });
            }
        }
        return allOptions;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hide, showRefreshIcon, disableRefreshButton, isRefreshing, classes, paths_1.featurePages]);
    React.useEffect(() => () => clearTimeout(timer.current), []);
    React.useEffect(() => {
        const debounceDialogTrigger = (0, debounce_1.default)(() => {
            (0, utils_1.checkAndTriggerWhatsNewDialog)({
                isUserPrefLoading,
                userPreferences,
                setUserPreference,
                currentVersion,
                hasWhatsNewJSON,
                showReleaseNotes,
                dispatchShowReleaseNotesDialog,
                dispatchShowWhatsNewDialog,
            });
        }, 2000);
        if (accountNodesTree.size > 0) {
            debounceDialogTrigger();
        }
    }, [isUserPrefLoading, userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.whatsNewViewed, accountNodesTree.size]); // eslint-disable-line react-hooks/exhaustive-deps
    return (<>
      <ButtonBase_1.default className={classes.navMenuItem} ref={moreButtonRef} onMouseOver={() => setShowMenuItems(true)} onMouseLeave={() => setShowMenuItems(false)}>
        <div>
          <img src={more_svg_1.default} alt="more"/>
        </div>
        <div className={(0, classnames_1.default)(classes.navText, classes.navItemText)}>
          More
        </div>
        <ChevronRight_1.default className={classes.mainNavChevronRightIcon}/>
      </ButtonBase_1.default>
      <Menu_1.default id="main-nav-sub-menu" 
    // @ts-expect-error: The expected type comes from property 'anchorEl' which is declared here on type 'IntrinsicAttributes & MenuProps'
    anchorEl={moreButtonRef} open={showMenuItems} autoFocus={false} className={(0, classnames_1.default)(classes.mainNavSubMenu, classes.moreNavSubMenu)}>
        <Divider_1.default sx={{ color: '#ccc', opacity: '0.7' }}>Help</Divider_1.default>
        {moreOptions.map(({ key, body, disabled, onClick }) => (<>
            <MenuItem_1.default key={key} onClick={() => {
                setShowMenuItems(false);
                onClick();
            }} className={classes.menuItems} onMouseOver={() => {
                clearTimeout(timer.current);
                setShowMenuItems(true);
            }} onMouseLeave={() => {
                timer.current = setTimeout(() => {
                    setShowMenuItems(false);
                }, 1000);
            }} disabled={disabled}>
              {body}
            </MenuItem_1.default>
            {key === 'supportFAQ' && <Divider_1.default />}
          </>))}
      </Menu_1.default>
    </>);
};
exports.default = MoreButton;
